<template>
    <div class="success-page-wrapper">
        <div class="decoration-shape shape-top-left"></div>
        <div class="decoration-shape shape-bottom-right"></div>
        <Navbar />
        <ContactSuccess />
    </div>
</template>

<script>
import Navbar from '../Layout/Navbar'
import ContactSuccess from '../Contact/ContactSuccess'

export default {
    name: 'ContactSuccessPage',
    components: {
        Navbar,
        ContactSuccess,
    }
}
</script>

<style scoped>
.success-page-wrapper {
    position: relative;
    background: #F4F8FF;
    overflow: hidden;
    min-height: 100vh;
}

/* Decorative shapes */
.decoration-shape {
    position: absolute;
    pointer-events: none;
    z-index: 0;
}

/* Top-left decorative shape */
.shape-top-left {
    top: -20px;
    left: -200px;
    width: 599.353px;
    height: 675.877px;
    transform: rotate(42.439deg);
    flex-shrink: 0;
    border-radius: 675.877px;
    background: #B9ECFF;
    filter: blur(150px);
}

/* Bottom-right decorative shape */
.shape-bottom-right {
    bottom: -300px;
    right: -400px;
    width: 897px;
    height: 825px;
    flex-shrink: 0;
    border-radius: 897px;
    background: radial-gradient(135.19% 91.5% at -35.46% 47.81%, rgba(201, 183, 255, 0.11) 0%, rgba(11, 113, 250, 0.11) 100%);
    filter: blur(115.1500015258789px);
}

/* Ensure content is above decorative shapes */
.success-page-wrapper > *:not(.decoration-shape) {
    position: relative;
}
</style>